import { Component, Renderer2 } from '@angular/core';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { scrollTop } from '@max/shared/helpers/scroll-helpers.model';
import { AppState } from '@max/store/reducers';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { showDarkTheme } from '../state/actions/login-menu.actions';
import { setWideMode } from '../state/actions/login-menu.actions';

@Component({
    selector: '[login]',
    templateUrl: './login.html'
})
export class LoginComponent extends BaseComponent {
    public businessUnitName: string;
    public clientDate: string;
    public clientTime: string;
    public iconThemeType = 'brightness_3';
    public iconWideMode = 'width_wide';
    public themeSelectType: string;
    public wideSelectType: string;
    public validatingLogin = false;

    constructor(
        private renderer: Renderer2,
        private store: Store<AppState>) {
        super();
    }

    ngOnInit() {
        this.auth.businessUnitUpdated.subscribe(bu => {
            this.businessUnitName = bu.businessUnitName;
        });

        // check to see if logged in. if not, try to silently login the user
        const self = this;
        window.setInterval(function() {
            self.updateClientDateTime.call(self);
        }, 1000);

        // localStorage.setItem('mvmDeepLinkTemp', window.location.pathname);
        const routePart = this.getRoutePartFromURL(document.URL);
        localStorage.setItem('mvmDeepLinkTemp', routePart);

        // TODO: unsubscribe
        this.store.select('authState')
            .subscribe(authState => {
                if (authState) {
                    const isThemeDark = !!authState.themeDark;
                    this.displayTheme(isThemeDark);
                    this.updateThemeMenuItem(isThemeDark);

                    const isWideMode = !!authState.wideMode;
                    this.displayWideModel(isWideMode);
                    this.updateWideModeMenuItem(isWideMode);
                }
            });
    }

    backToTop() {
        scrollTop();
    }

    redirectForBusinessUnitSelection() {
        this.auth.selectBusinessUnit();
    }

    redirectForLogin() {
        localStorage.removeItem('menuItems');
        // We are going to cache the mvmDeepLink into a backup slot 'mvmDeepLink2'
        // This is because the login.component.ts is loaded twice and 'mvmDeepLink'
        // will be overwritten with a different URI in the second load
        localStorage.setItem('mvmDeepLink', localStorage.getItem('mvmDeepLinkTemp'));
        this.auth.login();
    }

    redirectForLogout() {
        this.auth.logOut();
        localStorage.removeItem('menuItems');
        localStorage.removeItem('mvd:windowId');
        localStorage.removeItem('signalR:username');
        localStorage.removeItem('signalR:token');
    }

    switchTheme() {
        this.store.dispatch(showDarkTheme());
    }

    switchWideMode() {
        this.store.dispatch(setWideMode());
    }

    private displayTheme(isThemeDark) {
        isThemeDark ?
            this.renderer.addClass(document.body, 'theme--dark') :
            this.renderer.removeClass(document.body, 'theme--dark');
    }

    private displayWideModel(isWideMode) {
        isWideMode ?
            this.renderer.addClass(document.body, 'width--wide') :
            this.renderer.removeClass(document.body, 'width--wide');
    }

    private getRoutePartFromURL(postLogoutRedirectUri: string): string {
        var tempUrl = document.createElement('a');
        tempUrl.href = postLogoutRedirectUri;
        return tempUrl.pathname + tempUrl.search;
    }

    private updateClientDateTime() {
        this.clientDate = moment().format('dddd, MMMM Do YYYY');
        this.clientTime = moment().format('h:mm a');
    }

    private updateThemeMenuItem(isThemeDark: boolean) {
        if (isThemeDark) {
            this.themeSelectType = ' Default Theme';
            this.iconThemeType = 'wb_sunny';
        } else {
            this.themeSelectType = ' Dark Theme';
            this.iconThemeType = 'brightness_3';
        }
    }

    private updateWideModeMenuItem(isWideMode: boolean) {
        if (isWideMode) {
            this.wideSelectType = ' Standard Width';
            this.iconWideMode = 'width_normal';
        } else {
            this.wideSelectType = ' Wide Mode';
            this.iconWideMode = 'width_wide';
        }
    }
}
